<template>
  <div>
    <div
      v-if="!hoverActive && !navigationHovered && !ismobile"
      :class="['custom-cursor', { 'custom-cursor-hide': hideCursor }]"
      :style="cursorPosition"
    >
      <img src="arrow.svg" alt="" />
    </div>

    <div
      v-if="hoverActive || (navigationHovered && !ismobile)"
      class="custom-hover-cursor"
    >
      <img src="outer.svg" alt="" :style="hoverPosition" />
      <img class="inner" src="inner.svg" alt="" :style="hoverPositionInner" />
    </div>
    <div v-if="!ismobile" id="hide" class="home-wrapper">
      <div v-if="!ismobile" class="xy">
        <div class="main-menu__category">
          <div ref="catClipper" class="main-menu__category-clipper">
            {{ titleInfo.textinfo }} {{ titleInfo.category }}
          </div>
        </div>
        <div class="main-menu__image clipper" ref="imageClipper">
          <div ref="image" class="main-menu__image">
            <div ref="imagewrapper" class="main-menu__image-wrapper">
              <canvas
                ref="imageInside"
                v-for="(items, index) in displayImageArray"
                :key="index"
              ></canvas>
            </div>
          </div>
        </div>
        <div class="main-menu__counter">
          <div ref="countClipper" class="main-menu__counter-clipper">
            {{ titleInfo.counter }} / {{ projectsCount }}
          </div>
        </div>
        <div class="main-menu__line">
          <hr ref="lineClipper" />
        </div>
      </div>
      <div
        v-if="!ismobile"
        ref="wrapper"
        id="title"
        class="main-menu__titlewrapper"
        @mouseenter="hoverActive = true"
        @mouseleave="hoverActive = false"
      >
        <div
          ref="titleAnim"
          class="main-menu__title animtitle"
          @click="openProject(item.info.title, index)"
          v-for="(item, index) in projectsList"
          :key="index"
        >
          <fitty :options="options">
            <template v-slot:content> {{ item.info.title }} </template>
          </fitty>
        </div>
      </div>
    </div>

    <!-- Mobile -->
    <div v-if="ismobile" class="mobile__wrapper">
      <div
        v-for="(item, index) in projectsList"
        :key="index"
        @click="openMobileProject(item.info.title)"
        class="mobile__project"
      >
        <div ref="mobileimage" class="mobile__project-image">
          <img :src="item.images[0]" alt="" />
        </div>
        <div class="mobile__project-counter">
          <div ref="mobilecounter" class="mobile__project-counter-count">
            {{ item.info.counter }} / {{ projectsCount }}
          </div>
        </div>
        <div class="mobile__project-title">
          <fitty :options="options">
            <template v-slot:content>
              <div ref="mobiletitle" class="mobile__project-title-title">
                {{ item.info.title }}
              </div>
            </template>
          </fitty>
        </div>
        <div ref="mobilecategory" class="mobile__project-category">
          {{ item.info.textitem }} {{ item.info.category }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
import { gsap } from 'gsap';
import SplitText from 'gsap/SplitText';
import inertia from 'gsap/InertiaPlugin';
import Draggable from 'gsap/Draggable';
gsap.registerPlugin(SplitText, Draggable, inertia);
import projectData from '../../public/output.json';
import * as glsl from '../../public/glslcanvas.min.js';

export default {
  name: 'HomeComponent',
  props: {
    msg: String,
    projectData: Object,
    navigationHovered: Boolean,
  },
  $refs: {
    imageInside: HTMLElement,
  },
  data: function() {
    return {
      hoverActive: false,

      hover: false,
      hideCursor: true,
      cursorAngle: 0,
      xCursor: 0,
      yCursor: 0,
      screenWidth: 0,

      xChild: 0,
      yChild: 0,

      options: {
        minSize: 100,
        maxSize: 2000,
      },
      ismobile: '',
      projectsList: {},
      projectsCount: 0,

      titleInfo: {
        textinfo: '',
        category: '',
        counter: '',
      },
      displayImage: '',
      displayImageArray: [],

      containerX: 0,
      swipeCount: 0,
      openProjectIndex: 0,
      resizeWidth: 0,
      count: 0,

      textWidthScroll: 0,
      textOffsetLeft: 0,
      individualTextOffset: 0,
      individualTextOffsetCount: 0,
      clickAllowed: true,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.ismobile === false) {
      let timeDivider = 0.1;
      let delayDivider = 1;
      let after = this.openProjectIndex + 1;
      let before = this.openProjectIndex - 1;
      var tl = gsap.timeline();
      tl.staggerTo(
        '.charChild' + this.openProjectIndex + '',
        0.8,
        {
          x: -200,
          y: 0,
          duration: 1,
        },
        timeDivider
      );
      tl.to(
        '.charChild' + after + '',
        0.5,
        {
          x: -200,
          y: 0,
          duration: 1,
        },
        '-=.5'
      );
      if (before >= 1) {
        tl.to(
          '.charChild' + before + '',
          0.5,
          {
            x: -200,
            y: 0,
            duration: 1,
          },
          '-=.5'
        );
      }
      tl.to(
        this.$refs.image,
        {
          x: -this.$refs.image.clientWidth,
          duration: 1,
        },
        '-=' + delayDivider + ''
      );
      tl.to(
        this.$refs.catClipper,
        {
          y: this.$refs.catClipper.clientWidth,
          duration: 1,
        },
        '-=' + delayDivider + ''
      );
      tl.to(
        this.$refs.countClipper,
        {
          y: this.$refs.countClipper.clientWidth,
          duration: 1,
        },
        '-=' + delayDivider + ''
      );
      tl.to(
        this.$refs.lineClipper,
        {
          y: this.$refs.lineClipper.clientWidth,
          duration: 1,
        },
        '-=' + delayDivider + ''
      ).then(() => {
        next();
      });
    } else {
      let tl = gsap.timeline();
      tl.to(this.$refs.mobileimage, {
        x: this.$refs.mobileimage,
        duration: 1,
      });
      this.$refs.mobileimage.forEach((el) => {
        tl.to(
          el,
          {
            x: -el.clientWidth,
            duration: 1,
          },
          '-=0.95'
        );
      });
      this.$refs.mobilecounter.forEach((el) => {
        tl.to(
          el,
          {
            y: -el.clientWidth - 20,
            duration: 1,
          },
          '-=1'
        );
      });
      this.$refs.mobiletitle.forEach((el) => {
        tl.to(
          el,
          {
            y: -el.clientWidth,
            duration: 1,
          },
          '-=1'
        );
      });
      this.$refs.mobilecategory.forEach((el) => {
        tl.to(
          el,
          {
            x: -el.clientWidth,
            duration: 1,
          },
          '-=1'
        );
      });
      tl.to(this.$refs.mobileimage, {
        x: -this.$refs.mobileimage.clientWidth,
        duration: 0.2,
      }).then(() => {
        next();
      });
    }
  },
  created() {
    this.ismobile = window.isMobile;
    this.projectsList = Object.values(projectData);
    this.projectsList.forEach((el) => {
      this.projectsCount++;
      fetch(el.info[0])
        .then((r) => r.json())
        .then((res) => {
          el.info = res;
        })
        .then(() => {
          this.createTitleInfo();
        })
        .catch(function() {
          console.log();
        });
    });
  },
  computed: {
    cursorPosition() {
      return `transform: translateX(${this.xCursor - 32}px) translateY(${this
        .yCursor - 32}px) translateZ(0) translate3d(0, 0, 0) rotate(${
        this.cursorAngle
      }deg);`;
    },
    hoverPosition() {
      return `transform: translateX(${this.xChild - 32}px) translateY(${this
        .yChild - 32}px) translateZ(0) translate3d(0, 0, 0)`;
    },
    hoverPositionInner() {
      return `transform: translateX(${this.xCursor - 32}px) translateY(${this
        .yCursor - 32}px) translateZ(0) translate3d(0, 0, 0)`;
    },
  },
  mounted() {
    this.createTitleInfo();
    this.displayImage = this.projectsList[0].images[0];
    this.projectsCount = ('0' + this.projectsCount).slice(-2);
    this.projectsList.forEach((el) => {
      this.displayImageArray.push(el.images[0]);
    });

    if (this.ismobile === false) {
      setTimeout(this.draggable, 300);
    } else {
      this.mobileIn();
    }
    setTimeout(this.resize, 500);

    document.addEventListener('mousemove', this.moveCursor);
    document.addEventListener('mouseleave', (e) => {
      this.hideCursor = true;
    });
    document.addEventListener('mouseenter', (e) => {
      this.hideCursor = false;
    });
    document.addEventListener('click', (e) => {
      e.preventDefault();
      if (this.clickAllowed && !this.hoverActive) {
        this.nextSection(e);
      }
    });
  },
  methods: {
    handleGlsl() {
      const frag = `

#ifdef GL_ES
precision highp float;
#endif

#define MAX 6

uniform float u_time;
uniform vec2 u_resolution;
uniform vec2 u_mouse;

uniform sampler2D image1;
uniform float boolean;

varying vec3 v_normal;
varying vec2 v_texcoord;


#define NUM_OCTAVES 5

float rand(vec2 n) {
return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);
}

float noise(vec2 p){
vec2 ip = floor(p);
vec2 u = fract(p);
u = u*u*(3.0-2.0*u);

float res = mix(
  mix(rand(ip),rand(ip+vec2(1.0,0.0)),u.x),
  mix(rand(ip+vec2(0.0,1.0)),rand(ip+vec2(1.0,1.0)),u.x),u.y);
return res*res;
}

float fbm(vec2 x) {
float v = 0.0;
float a = 0.5;
vec2 shift = vec2(100);
// Rotate to reduce axial bias
mat2 rot = mat2(cos(0.5), sin(0.5), -sin(0.5), cos(0.50));
for (int i = 0; i < NUM_OCTAVES; ++i) {
  v += a * noise(x);
  x = rot * x * 2.0 + shift;
  a *= 0.5;
}
return v;
}


void main(void)
{
vec2 uv = v_texcoord;
vec2 mouse = u_mouse / u_resolution;
float wave;
wave = fbm(2.0 * uv + 0.2 * u_time);
uv -= 0.5;

// float strength = smoothstep(0.0 , 0.0, wave) - smoothstep(0.9, 1.0, wave);
// float distortion = mix(1.0, 0.5 + strength , wave);
float strength = smoothstep(0.0, 0.0, wave / 2.0) - smoothstep(0.5, 1.0, wave / 2.0);
float distortion = mix(1.1, 0.6 + strength , wave / 2.0);


uv *= distortion;
uv += 0.5;

//uv.y = 1.0 - uv.y;

if(uv.x < 0.0 || uv.x > 1.0 || uv.y < 0.0 || uv.y > 1.0){
  discard;
}

vec4 color = texture2D(image1, uv);

gl_FragColor = color;
}

`;

      const canvas = document.querySelectorAll('canvas');
      canvas.forEach((canvas, index) => {
        const sandbox = new GlslCanvas(canvas);

        const sizer = () => {
          const ww = this.$refs.imageClipper.clientWidth;
          const wh = this.$refs.imageClipper.clientHeight;
          const dpi = window.devicePixelRatio;

          const s = Math.max(ww, wh);

          if (canvas) {
            canvas.width = ww;
            canvas.height = wh;
            canvas.style.width = ww + 'px';
            canvas.style.height = wh + 'px';
          }
        };
        const adjustImage = () => {
          let imagePos = this.$refs.imageInside[0].clientWidth;
          gsap.to(this.$refs.imagewrapper, {
            x: -imagePos * this.count,
          });
        };
        sizer();

        window.addEventListener('resize', function() {
          sizer();
          adjustImage();
        });

        sandbox.setUniform('boolean', 1.1);
        sandbox.setUniform('image1', this.displayImageArray[index]);
        sandbox.load(frag);
      });
    },

    nextSection(mouseevent) {
      let dir;
      mouseevent.x < this.screenWidth / 2 ? (dir = 'left') : (dir = 'right');
      this.endDrag(dir);
      this.moveToNextSection();
    },
    moveCursor(e) {
      this.xCursor = e.clientX;
      this.yCursor = e.clientY;

      setTimeout(() => {
        this.xChild = e.clientX;
        this.yChild = e.clientY;
      }, 100);

      let rightborder = window.innerWidth / 2 + 100 - e.clientX;

      if (rightborder <= 0) {
        rightborder = 0;
      } else if (rightborder >= 200) {
        rightborder = 200;
      }

      let percent = (1 / 200) * rightborder;
      let angle = this.lerp(0, 180, percent);
      this.cursorAngle = angle;
      // console.log(e.clientX, window.innerWidth);
    },

    lerp(val1, val2, t) {
      return (1 - t) * val1 + val2 * t;
    },

    mobileIn() {
      let width = window.innerWidth;
      let tl = gsap.timeline();
      tl.from(this.$refs.mobileimage, {
        x: this.$refs.mobileimage,
        duration: 1,
      });
      this.$refs.mobileimage.forEach((el) => {
        tl.from(
          el,
          {
            x: el.clientWidth,
            duration: 1,
          },
          '-=0.95'
        );
      });
      this.$refs.mobilecounter.forEach((el) => {
        tl.from(
          el,
          {
            y: el.clientWidth - 20,
            duration: 1,
          },
          '-=1'
        );
      });
      this.$refs.mobiletitle.forEach((el) => {
        tl.from(
          el,
          {
            y: width,
            duration: 1,
          },
          '-=1'
        );
      });
      this.$refs.mobilecategory.forEach((el) => {
        tl.from(
          el,
          {
            x: el.clientWidth,
            duration: 1,
          },
          '-=1'
        );
      });
    },
    resize() {
      this.screenWidth = window.innerWidth;
      this.textOffsetLeft = this.screenWidth / 10;

      this.resizeWidth =
        (window.innerWidth - this.$refs.titleAnim[this.count].clientWidth) / 2;

      this.$refs.titleAnim[0].style.marginLeft = this.resizeWidth + 'px';
      window.addEventListener('resize', this.resize);
    },

    moveToNextSection() {},

    draggable() {
      //Set Center of Title at startup

      let width = (window.innerWidth - this.$refs.titleAnim[0].clientWidth) / 2;
      this.$refs.titleAnim[0].style.marginLeft = width + 'px';

      this.$refs.titleAnim.forEach((el, index) => {
        new SplitText(el, {
          type: 'chars, words',
          charsClass: 'charParent' + index + '',
        });
        new SplitText(el, {
          type: 'chars, words',
          charsClass: 'charChild' + index + '',
        });
      });

      //Create Object Array with titles
      var boxes = this.$refs.titleAnim;
      var snap = [];
      for (let i = 0; i < boxes.length; i++) {
        snap.push(
          -boxes[i].getBoundingClientRect().left +
            (window.innerWidth - boxes[i].clientWidth) / 2
        );
      }

      let show = document.getElementById('hide');
      show.style.visibility = 'inherit';

      this.handleGlsl();

      var tl = gsap.timeline();
      tl.staggerFrom(
        '.charChild0, .charChild1',
        0.8,
        {
          x: 200,
          y: 0,
        },
        0.1
      );
      tl.from(
        this.$refs.imagewrapper,
        {
          x: this.$refs.imagewrapper.clientWidth,
          duration: 1,
        },
        '-=1'
      );
      tl.from(
        this.$refs.catClipper,
        {
          y: -this.$refs.catClipper.clientWidth,
          duration: 1,
        },
        '-=1'
      );
      tl.from(
        this.$refs.countClipper,
        {
          y: -this.$refs.countClipper.clientWidth,
          duration: 1,
        },
        '-=1'
      );
      tl.from(
        this.$refs.lineClipper,
        {
          y: -this.$refs.lineClipper.clientWidth,
          duration: 1,
        },
        '-=1'
      );
    },
    createTitleInfo() {
      let collection = this.projectsList[0];
      let info = this.titleInfo;
      info.textinfo = collection.info.textitem;
      info.category = collection.info.category;
      info.counter = collection.info.counter;
    },
    endSize() {
      gsap.to(this.$refs.titleAnim, {
        scale: 1,
        duration: 0.3,
      });
    },
    endDrag(e) {
      //get Width of Image for Animation
      let imagePos = this.$refs.imageInside[0].clientWidth;

      this.clickAllowed = false;
      // Offset of text width plus offset(margin)
      if (e == 'right' && this.count <= this.projectsList.length - 2) {
        //Calculate Offset of each Element to subtract
        this.individualTextOffset =
          (window.innerWidth -
            this.$refs.titleAnim[this.count + 1].clientWidth) /
          2;
        this.$refs.titleAnim[0].style.marginLeft =
          this.individualTextOffset + 'px';

        this.textWidthScroll += -Math.abs(
          this.$refs.titleAnim[this.count].clientWidth + this.textOffsetLeft
        );
        this.individualTextOffsetCount = this.count + 1;
      } else if (e == 'left' && this.count > 0) {
        this.individualTextOffset =
          (window.innerWidth -
            this.$refs.titleAnim[this.count - 1].clientWidth) /
          2;
        this.$refs.titleAnim[0].style.marginLeft =
          this.individualTextOffset + 'px';

        this.textWidthScroll += Math.abs(
          this.$refs.titleAnim[this.count - 1].clientWidth + this.textOffsetLeft
        );
        this.individualTextOffsetCount = this.count - 1;
      }
      gsap.from(this.$refs.titleAnim, {
        scale: 0.75,
      });

      gsap.to(this.$refs.titleAnim, {
        scale: 1,
        duration: 0.5,
        x: this.textWidthScroll,
      });
      let dir = e;

      if (dir == 'left') {
        this.count--;
        if (this.count < 0) {
          this.count = 0;
        }
        gsap.to(this.$refs.imagewrapper, {
          x: -imagePos * this.count,
        });
        this.titleInfo.counter = this.count + 1;
        this.titleInfo.category = this.projectsList[
          this.titleInfo.counter - 1
        ].info.category;
        if (this.titleInfo.counter >= this.projectsCount) {
          this.titleInfo.counter = this.projectsCount;
        }
        this.titleInfo.counter = ('0' + this.titleInfo.counter).slice(-2);
        this.hasSwipedRight = true;
        this.containerX = document
          .getElementById('title')
          .getBoundingClientRect().left;
      } else if (dir === 'right') {
        this.count++;
        if (this.count >= this.projectsList.length) {
          this.count = this.projectsList.length - 1;
        }
        gsap.to(this.$refs.imagewrapper, {
          x: -imagePos * this.count,
        });
        this.titleInfo.counter = this.count + 1;
        this.titleInfo.category = this.projectsList[
          this.titleInfo.counter - 1
        ].info.category;
        if (this.titleInfo.counter <= 1) {
          this.titleInfo.counter = 1;
        }
        this.titleInfo.counter = ('0' + this.titleInfo.counter).slice(-2);
        this.containerX = document
          .getElementById('title')
          .getBoundingClientRect().left;
      }
      this.clickAllowed = true;
    },
    leftRightChecker() {
      let titlecontainer = document
        .getElementById('title')
        .getBoundingClientRect().left;
      let check = titlecontainer - this.containerX;
      return check;
    },
    openProject(itm, index) {
      this.openProjectIndex = index;
      this.$router
        .push({
          name: 'project',
          path: 'project/taask',
          params: {
            project: itm,
            from: 'push',
            index: index,
            projectDataProp: projectData,
          },
        })
        .catch((err) => {});
    },
    openMobileProject(path) {
      this.$router
        .push({
          name: 'project',
          path: path,
          params: { project: path, from: 'push', projectDataProp: projectData },
        })
        .catch((err) => {});
    },
  },
};
</script>
